import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";

/**
 * TCPA / A2P 10DLC consent block. Renders only when the user has chosen a
 * notification method that includes SMS. Parent controls the checked state
 * and gates its submit button on `checked`.
 */
export default function SMSConsentBlock({ checked, onCheckedChange, testIdPrefix = "sms-consent" }) {
  return (
    <div
      className="mt-3 p-3 border border-amber-800/50 bg-amber-900/10 rounded-sm space-y-2.5"
      data-testid={`${testIdPrefix}-block`}
    >
      <div className="flex items-start gap-2.5">
        <Checkbox
          id={`${testIdPrefix}-checkbox`}
          checked={checked}
          onCheckedChange={(v) => onCheckedChange(Boolean(v))}
          data-testid={`${testIdPrefix}-checkbox`}
          className="mt-0.5 border-amber-500 data-[state=checked]:bg-amber-500 data-[state=checked]:border-amber-500"
        />
        <label
          htmlFor={`${testIdPrefix}-checkbox`}
          className="text-[12px] leading-relaxed text-zinc-300 select-none cursor-pointer"
        >
          Yes, I would like to receive automated text messages from ZigZagX about trade ideas and trade
          executions. I understand there may be multiple updates per day depending on how many trades I follow
          inside the ZigZagX platform.
        </label>
      </div>
      <div className="pl-7 text-[11px] leading-relaxed text-zinc-500 space-y-1">
        <p>
          <span className="text-zinc-400 font-medium">Message Frequency:</span> You may receive multiple messages
          per day depending on how many trades you follow within the platform.
        </p>
        <p>
          <span className="text-zinc-400 font-medium">Standard Rates:</span> Message and data rates may apply
          depending on your mobile phone service plan.
        </p>
        <p>
          <span className="text-zinc-400 font-medium">Help &amp; Stop:</span> You may STOP text notifications in your
          account Settings inside the ZigZagX web platform. You may request HELP by email to{" "}
          <a href="mailto:admin@zigzagx.com" className="text-blue-400 hover:underline">admin@zigzagx.com</a>.
        </p>
        <p className="pt-1">
          See our{" "}
          <Link to="/terms" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline" data-testid={`${testIdPrefix}-tos-link`}>
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline" data-testid={`${testIdPrefix}-privacy-link`}>
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
